import _Textarea from './Textarea';

import './style/index.js';

export type { TextareaProps } from './Textarea';
export * from './type';

export const Textarea = _Textarea;
export default Textarea;
